import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AreaLabel from '@src/components/common/AreaLabel.jsx';
import PropTypes from 'prop-types';
import React from 'react';

const AreaLegend = ({color, prefix = '', squareMeters, sx}) => {
  const label = prefix ? `${prefix} area:` : 'Area:';

  return (
    <Stack direction="row" sx={{gap: 1}}>
      <Box
        sx={[
          theme => ({
            backgroundColor: () => {
              // use a washed out "lighter" color
              const base =
                theme.vars.palette[color]?.light ??
                `color-mix(in srgb, ${color[500]}, white 40%)`;

              // add transparency
              return `color-mix(in srgb, ${base}, transparent 70%)`;
            },
            border: 'solid 2px',
            borderColor: theme.vars.palette[color]?.main ?? color[500],
            display: 'inline-block',
            height: '1.25em',
            width: '1.25em',
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />

      <Typography component="span" noWrap variant="subtitle2">
        {squareMeters ? (
          <>
            {label} <AreaLabel squareMeters={squareMeters} />
          </>
        ) : (
          prefix
        )}
      </Typography>
    </Stack>
  );
};

AreaLegend.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  prefix: PropTypes.string,
  squareMeters: PropTypes.number,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.func]),
};

export default AreaLegend;
